import React from 'react';
import OthersDataTable from './OthersDataTable';
import OthersVisualInsights from './OthersVisualInsights';
import DataPoints from '../DataPoints';
import { exportToCSV } from '../../../../utils/exportUtils';
import { getOthersData } from '../../../../services/adminService';

export const othersCohorts = [
    { key: "lbw", label: "Low Birth Weight Babies (0-6 months)", non: "lbw_non", mild: "lbw_mild", mod: "lbw_mod", sev: "lbw_sev" },
    { key: "child_6_59m", label: "Children (6-59 months)", non: "child_6_59m_non", mild: "child_6_59m_mild", mod: "child_6_59m_mod", sev: "child_6_59m_sev" },
    { key: "child_5_9y", label: "Children (5-9 years)", non: "child_5_9y_non", mild: "child_5_9y_mild", mod: "child_5_9y_mod", sev: "child_5_9y_sev" },
    { key: "adol_10_19y", label: "Adolescents (10-19 years)", non: "adol_10_19y_non", mild: "adol_10_19y_mild", mod: "adol_10_19y_mod", sev: "adol_10_19y_sev" },
    { key: "preg", label: "Pregnant Women", non: "preg_non", mild: "preg_mild", mod: "preg_mod", sev: "preg_sev" },
    { key: "lact", label: "Lactating mothers", non: "lact_non", mild: "lact_mild", mod: "lact_mod", sev: "lact_sev" },
    { key: "wra", label: "WRA (20-49 years)", non: "wra_non", mild: "wra_mild", mod: "wra_mod", sev: "wra_sev" }
];

const calculateTotalsFn = (chartRecords) => {
    let non = 0, mild = 0, mod = 0, sev = 0;
    chartRecords.forEach((r) => {
        othersCohorts.forEach((c) => {
            non += Number(r[c.non] || 0);
            mild += Number(r[c.mild] || 0);
            mod += Number(r[c.mod] || 0);
            sev += Number(r[c.sev] || 0);
        });
    });
    return { non, mild, mod, sev };
};

const exportCSVFn = (localData, sourceName) => {
    const headers = [
        "ID", "Report Date", "District", "State",
        "LBW Non-Anaemic", "LBW Mild", "LBW Moderate", "LBW Severe",
        "Children (6-59m) Non-Anaemic", "Children (6-59m) Mild", "Children (6-59m) Moderate", "Children (6-59m) Severe",
        "Children (5-9y) Non-Anaemic", "Children (5-9y) Mild", "Children (5-9y) Moderate", "Children (5-9y) Severe",
        "Adolescents (10-19y) Non-Anaemic", "Adolescents (10-19y) Mild", "Adolescents (10-19y) Moderate", "Adolescents (10-19y) Severe",
        "Pregnant Women Non-Anaemic", "Pregnant Women Mild", "Pregnant Women Moderate", "Pregnant Women Severe",
        "Lactating Mothers Non-Anaemic", "Lactating Mothers Mild", "Lactating Mothers Moderate", "Lactating Mothers Severe",
        "WRA Non-Anaemic", "WRA Mild", "WRA Moderate", "WRA Severe"
    ];

    const fields = [
        "id", "report_date", "district_name", "state_name",
        "lbw_non", "lbw_mild", "lbw_mod", "lbw_sev",
        "child_6_59m_non", "child_6_59m_mild", "child_6_59m_mod", "child_6_59m_sev",
        "child_5_9y_non", "child_5_9y_mild", "child_5_9y_mod", "child_5_9y_sev",
        "adol_10_19y_non", "adol_10_19y_mild", "adol_10_19y_mod", "adol_10_19y_sev",
        "preg_non", "preg_mild", "preg_mod", "preg_sev",
        "lact_non", "lact_mild", "lact_mod", "lact_sev",
        "wra_non", "wra_mild", "wra_mod", "wra_sev"
    ];

    exportToCSV(localData, sourceName, headers, fields);
};

// Mock fetch function since there's no API
const fetchOthersData = async () => {
    return {
        chartData: { overallTotals: { total_non_anaemic: 0, total_mild: 0, total_moderate: 0, total_severe: 0 }, dailyTrends: [], records: [] },
        tableData: { records: [], total: 0 }
    };
};

const OthersDataPoints = ({ onTotalsCalculated }) => {
    return (
        <DataPoints
            sourceName="OTHERS"
            fetchDataFn={getOthersData}
            onTotalsCalculated={onTotalsCalculated}
            renderVisuals={(chartData, loading, overallTotals) => (
                <OthersVisualInsights chartData={chartData} loading={loading} overallTotals={overallTotals} />
            )}
            renderTable={(records, loading, currentPage, setCurrentPage, totalCount, totalPages, rowsPerPage) => (
                <OthersDataTable
                    records={records} loading={loading}
                    currentPage={currentPage} setCurrentPage={setCurrentPage}
                    totalCount={totalCount} totalPages={totalPages} rowsPerPage={rowsPerPage}
                />
            )}
            exportCSVFn={exportCSVFn}
            calculateTotalsFn={calculateTotalsFn}
        />
    );
};

export default OthersDataPoints;
